import { Button, ButtonGroup, Stack } from '@chakra-ui/react';
import { BsLightningChargeFill } from "react-icons/bs";
import { useNavigate } from 'react-router-dom'; 


const WholesaleButton = () => {
    const navigate = useNavigate();

  const handleClick = () => {
    navigate('/products');
  };
  return (
    <Stack direction="row" spacing={4}>
      <Button leftIcon={<BsLightningChargeFill/>} colorScheme="yellow" variant="solid" onClick={handleClick} className="flickeringButton">
        Wholesale Products
      </Button>
    </Stack>
  );
};

export default WholesaleButton;
